import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { format } from 'date-fns';
import React from 'react';
import { getStatusInfo } from '../utils/certificateStatusUtils';

const CSAWCertificateVerification = ({ certificate }) => {
   const isExpired = certificate.expiryDate ? new Date(parseInt(certificate.expiryDate)) < new Date() : false;
   const statusInfo = getStatusInfo(certificate.certificateStatus, isExpired);

   const formatDate = (timestamp) => {
      if (!timestamp) return null;
      return format(new Date(parseInt(timestamp)), 'MMMM d, yyyy');
   };

   // Handle cases where csawCertificateData might be undefined
   const certificateData = certificate.csawCertificateData || {};
   const chainsawDetails = certificateData.chainsawDetails || {};

   return (
      <div className="space-y-6">
         <div className="text-center mb-8">
            <statusInfo.icon className="mx-auto h-12 w-12 text-gray-600" />
            <h2 className="mt-4 text-3xl font-bold text-gray-900">
               Chainsaw Registration Certificate Verification
            </h2>
         </div>

         <Card className="p-6 mb-6">
            <div className="flex justify-between items-center mb-6">
               <h3 className="text-lg font-semibold">Certificate Status</h3>
               <Badge className={statusInfo.color}>
                  {statusInfo.label}
               </Badge>
            </div>

            <div className="space-y-4">
               <div>
                  <h4 className="text-sm font-medium text-gray-500">Certificate Number</h4>
                  <p className="text-lg">{certificate.certificateNumber}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Owner Information</h4>
                  <p className="text-lg">{certificateData.ownerName}</p>
                  <p className="text-gray-600">{certificateData.address}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Chainsaw Details</h4>
                  <div className="grid grid-cols-2 gap-4 mt-2">
                     <div>
                        <p><span className="font-medium">Brand:</span> {chainsawDetails.brand}</p>
                        <p><span className="font-medium">Model:</span> {chainsawDetails.model}</p>
                        <p><span className="font-medium">Serial No:</span> {chainsawDetails.serialNumber}</p>
                     </div>
                     <div>
                        <p><span className="font-medium">Power Output:</span> {chainsawDetails.powerOutput}</p>
                        <p><span className="font-medium">Max Guide Bar:</span> {chainsawDetails.maxLengthGuidebar}</p>
                        <p><span className="font-medium">Origin:</span> {chainsawDetails.countryOfOrigin}</p>
                     </div>
                  </div>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Validity Period</h4>
                  <p><span className="font-medium">Issue Date:</span> {formatDate(certificate.dateIssued)}</p>
                  <p><span className="font-medium">Expiry Date:</span> {formatDate(certificate.expiryDate)}</p>
               </div>
            </div>
         </Card>
      </div>
   );
};

export default CSAWCertificateVerification;
